export const TALENT_TYPES = [
  { value: "modeling", label: "Modeling" },
  { value: "content-creation", label: "Content Creator" },
  { value: "both", label: "Both" },
] as const;

export type TalentTypeValue = (typeof TALENT_TYPES)[number]["value"];
